import { VuexModule, Module, Action, Mutation } from "vuex-module-decorators";
import MenuSet from "@/model/menuSet";

@Module({ namespaced: true })
export default class MenuSetModule extends VuexModule {
  public menuSetList: MenuSet[] = [];
  public setMenuList: MenuSet[] = [];

  @Mutation
  setMenuSetList(menuSet: MenuSet[]): void {
    this.setMenuList = menuSet;
  }

  @Mutation
  addMenuSetList(menuSet: MenuSet): void {
    this.setMenuList.push(menuSet);
  }

  @Mutation
  editMenuSetList(menuSet: MenuSet): void {
    this.setMenuList.map((value, key) => {
      if (value.identifier === menuSet.identifier) {
        this.setMenuList.splice(key, 1, menuSet)
      }
    });
  }

  @Mutation
  remove(index: number): void {
    this.setMenuList.splice(index, 1);
  }

  @Action({ rawError: true })
  setMenuSet(menuSet: MenuSet) {
    this.context.commit("set", menuSet);
  }

  @Action({ rawError: true })
  addMenuSetToList(menuSet: MenuSet) {
    this.context.commit("addMenuSetList", menuSet);
  }

  @Action({ rawError: true })
  editMenuSetToList(menuSet: MenuSet) {
    this.context.commit("editMenuSetList", menuSet);
  }

  @Action({ rawError: true })
  removeMenuSetInList(index: number) {
    this.context.commit("remove", index);
  }

  @Action({ rawError: true })
  clearList() {
    this.context.commit("setMenuSetList", []);
  }

  get getMenuSetList(): MenuSet[] {
    return this.setMenuList;
  }
}
